import Model from './AdminBaseModel'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { isEmpty } from 'lodash'

dayjs.extend(utc)

export default class Tradie extends Model {
  resource() {
    return 'tradies'
  }

  get isCompleted() {
    return !isEmpty(this.completed_at)
  }

  get addedDate() {
    return dayjs.utc(this.created_at).format('MMM DD, YYYY hh:mm A')
  }
}
